import { useState } from "react";

import { lightTheme } from "@hl/base-components/lib/theme/light/theme";
import { CustomPageRenderer } from "@hl/shared-features/lib/features/builder/CustomPageRenderer";
import { Box, MantineProvider } from "@mantine/core";
import { useParams } from "react-router-dom";
import { LoadingPage } from "~/../../base-components/lib/LoadingPage";
import {
  FEATURE_FLAGS,
  useFeatureFlags,
} from "~/../../shared-features/lib/features/auth/hooks";

import {
  ListCuratedSpacesQuery,
  useListCuratedSpacesQuery,
} from "./curation.queries.graphql.generated";

export const PreviewCuration = () => {
  // const navigate = useNavigate();
  const { curationId } = useParams();
  const [curation, setCuration] = useState<
    ListCuratedSpacesQuery["listCuratedSpaces"][0] | undefined | null
  >(null);

  const enableCuratedSpacesAuthor = useFeatureFlags(
    FEATURE_FLAGS.ENABLE_CURATED_SPACES_AUTHOR
  );

  const { loading, error } = useListCuratedSpacesQuery({
    skip: enableCuratedSpacesAuthor !== true,
    onCompleted(data) {
      console.log("Curated spaces", data);
      if (data.listCuratedSpaces == null) return;
      const curation = data.listCuratedSpaces.find(
        (curation) => curation.slug === curationId
      );
      setCuration(curation);
    },
  });

  if (loading) {
    return <LoadingPage />;
  }

  if (error) {
    return <Box>Error loading curated spaces</Box>;
  }

  if (curation?.draft == null) {
    return <Box>Curation not found</Box>;
  }

  return (
    <MantineProvider theme={lightTheme} inherit withGlobalStyles>
      <CustomPageRenderer
        cssString={curation.draft.css}
        htmlString={curation.draft.html}
      />
    </MantineProvider>
  );
};
